import { EsportController as Esport } from "./controller";

export default Esport;
